import { AbstractPageTemplate } from '../AbstractPageTemplate/AbstractPageTemplate';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const ListingPage = props => {
  return /*#__PURE__*/_jsx(AbstractPageTemplate, Object.assign({}, props, {
    horizontalDivider: true,
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'ListingPage'
  }));
};
ListingPage.displayName = 'ListingPage';